/*
  Luvari on-demand menu panels (web_dev 2026-10-29, speed step 1).
  The header prints only the top level of the phone drawer; its submenus come from sections/luv-menu-mobile,
  fetched when the phone is idle after load or when the visitor reaches for the menu (the desktop menu is
  server-rendered, seo_aeo option B, 10-29; sections/luv-menu-desktop is kept but unused), and kept in localStorage so later
  pages open them instantly. The cache key carries a signature of the menu (data-luv-menu-lazy); the
  copy is refreshed once per browser session and after 6 hours.
*/
(function () {
  var D = document, W = window;
  var root = D.querySelector('[data-luv-menu-lazy]');
  if (!root || !W.fetch || !W.Promise) return;
  var VER = root.getAttribute('data-luv-menu-lazy');
  var BASE = root.getAttribute('data-luv-menu-url');
  var TTL = 6 * 3600 * 1000;
  var DESK = W.matchMedia('(min-width: 990px)');
  var mem = {}, inflight = {};

  function key(k) { return 'luvMenu:' + k + ':' + VER; }
  function load(k) { try { var o = JSON.parse(W.localStorage.getItem(key(k)) || 'null'); return o && o.h ? o : null; } catch (e) { return null; } }
  function save(k, h) { try { W.localStorage.setItem(key(k), JSON.stringify({ h: h, t: Date.now() })); } catch (e) {} }
  function seen(k) { try { return W.sessionStorage.getItem(key(k)) === '1'; } catch (e) { return false; } }
  function markSeen(k) { try { W.sessionStorage.setItem(key(k), '1'); } catch (e) {} }
  function idle(fn) { (W.requestIdleCallback || function (f) { return setTimeout(f, 1500); })(fn, { timeout: 4000 }); }

  function fetchKind(k) {
    if (inflight[k]) return inflight[k];
    var p = fetch(BASE + 'luv-menu-' + k, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        var h = j['luv-menu-' + k];
        if (!h) throw new Error('empty');
        mem[k] = h; save(k, h); markSeen(k);
        return h;
      });
    inflight[k] = p;
    p.then(function () { delete inflight[k]; }, function () { delete inflight[k]; });
    return p;
  }

  function get(k) {
    if (mem[k]) return Promise.resolve(mem[k]);
    var c = load(k);
    if (c) {
      mem[k] = c.h;
      if (!seen(k) || Date.now() - c.t > TTL) idle(function () { fetchKind(k).catch(function () {}); });
      return Promise.resolve(c.h);
    }
    return fetchKind(k);
  }

  function panelFrom(h, n) {
    var t = D.createElement('template');
    t.innerHTML = h;
    return t.content.querySelector('[data-luv-panel="' + n + '"]');
  }

  // The panels are rendered once for every page, so the current-page highlight is set here.
  function markCurrent(nodes) {
    var here = location.pathname.replace(/\/$/, '');
    nodes.forEach(function (n) {
      if (!n.querySelectorAll) return;
      n.querySelectorAll('a[href]').forEach(function (a) {
        if (a.pathname.replace(/\/$/, '') === here && a.pathname !== '/') {
          a.setAttribute('aria-current', 'page');
          if (a.classList.contains('menu-drawer__menu-item')) a.classList.add('menu-drawer__menu-item--active');
        }
      });
    });
  }

  // Dawn's drawer binds its summary handlers at start-up; give the new phone submenus the same handler.
  function bindDrawer(nodes) {
    var drawer = root.querySelector('header-drawer');
    if (!drawer || typeof drawer.onSummaryClick !== 'function') return;
    nodes.forEach(function (n) {
      if (!n.querySelectorAll) return;
      n.querySelectorAll('summary').forEach(function (s) { s.addEventListener('click', drawer.onSummaryClick.bind(drawer)); });
    });
  }

  function fill(slot, retried) {
    if (slot.getAttribute('data-luv-state')) return;
    var k = slot.getAttribute('data-luv-kind'), n = slot.getAttribute('data-luv-slot');
    slot.setAttribute('data-luv-state', 'loading');
    (retried ? fetchKind(k) : get(k)).then(function (h) {
      if (!slot.isConnected) return;
      var p = panelFrom(h, n);
      if (!p) {
        slot.removeAttribute('data-luv-state');
        if (!retried) fill(slot, true);
        return;
      }
      var nodes = Array.prototype.slice.call(p.childNodes);
      slot.replaceWith.apply(slot, nodes);
      markCurrent(nodes);
      if (k === 'mobile') bindDrawer(nodes);
    }).catch(function () { slot.removeAttribute('data-luv-state'); });
  }

  // A menu item opens (hover on desktop sets [open]; a tap on the phone drawer toggles it).
  D.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || !root.contains(d)) return;
    var slot = d.querySelector(':scope > [data-luv-slot]');
    if (slot) fill(slot);
    else prefetch();
  }, true);

  // Only fetch a kind this page actually has slots for (the desktop menu is server-rendered since option B).
  function prefetch() {
    var k = DESK.matches ? 'desktop' : 'mobile';
    if (!root.querySelector('[data-luv-slot][data-luv-kind="' + k + '"]')) return;
    get(k).catch(function () {});
  }
  ['pointerover', 'touchstart', 'focusin'].forEach(function (ev) {
    root.addEventListener(ev, prefetch, { once: true, passive: true });
  });
  if (D.readyState === 'complete') idle(prefetch);
  else W.addEventListener('load', function () { idle(prefetch); });
})();
